/**
 * Escape a string so it can be used safely inside CSS attribute selectors.
 * @param {string} value - Raw attribute value to escape for selectors.
 * @returns {string}
 */
export function escapeAttrValue(value) {
  if (window.CSS && typeof window.CSS.escape === "function") {
    return window.CSS.escape(value);
  }
  return `${value}`.replace(/("|\\)/g, "\\$1");
}
